/**
 * Analytics constants.
 * Contains tracking event names, categories, and configuration values.
 *
 * @module constants/analytics
 */

// Navigation Section Types
/** Category section identifier for analytics */
export const CATEGORY_SECTION = 'Category Section'

/** Merchandising section identifier for analytics */
export const MERCHANDISING_SECTION = 'Merchandising Section'

/** Top navigation level 1 identifier for analytics */
export const TOP_NAV_LEVEL = 'Top Nav Level 1'

// Navigation Sub-Sections
/** Top navigation section name */
export const TOP_NAV = 'TopNav'

/** Top bar section identifier (brands banner) */
export const TOP_BAR = 'TopBar'

/** Footer navigation section identifier */
export const FOOTER_NAVIGATION = 'FooterNavigation'

// Link Types
/** Text layout link type */
export const TEXT_LAYOUT_LINK = 'Text Layout Link'

/** Visual tile link type */
export const VISUAL_TILE = 'Visual Tile'

/** Promotional tile link type */
export const PROMO_TILE = 'Promo Tile'

/** Tile list tile type for images where all the columns are visual */
export const TILE_LIST_TILE = 'Tile List Tile'

// Navigation Constants
/** Page type identifier for product detail pages */
export const PAGE_TYPE_PDP = 'productpage'

// Navigation Detail Thresholds
/** Threshold for deduplicating top nav navigation details */
export const TOP_NAV_DETAIL_THRESHOLD = 1

/** Threshold for deduplicating category navigation details */
export const CATEGORY_DETAIL_THRESHOLD = 2

/** Tracking event names used throughout the application */
export const TRACKING_EVENTS = {
  NAVIGATION_CLICKED: 'Navigation Clicked',
  HEADER_LINK_CLICKED: 'Header Link Clicked',
  FLY_OUT_VIEWED: 'Fly-Out Viewed',
  FLY_OUT_CLICKED: 'Fly-Out Clicked',
  VAT_OPTION_SELECTED: 'VAT Option Selected',
  EXPERIMENT_VIEWED: 'Experiment Viewed',
} as const

// Tracking Categories
export const TRACKING_CATEGORIES = {
  HEADER: 'Header',
  FLY_OUT: 'Fly-Out',
  VAT: 'VAT',
  POP_UP: 'Pop-Up',
} as const

// Experiment Names
export const NAV_FLYOUT_EXPERIMENT = 'nav_flyout_event'
